"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Retrieve the list of States
 * @param country
 */
exports.getStatesDropDownList = (country) => GetUSStateOptions(country);
/**
 * Find the States Abreviation by the Name
 * @param stateName
 */
exports.getStateAbreviation = (stateName) => {
    if (stateName === null || stateName === '') {
        return '';
    }
    const states = GetUSStateOptions();
    const state = states.find((a) => a.label === stateName);
    if (state === undefined) {
        return '';
    }
    return state.value;
};
/**
 * Find the States Name by the Abreviation
 * @param stateAbrev
 */
exports.getStateName = (stateAbrev) => {
    if (stateAbrev === null || stateAbrev === '') {
        return '';
    }
    const states = GetUSStateOptions();
    const state = states.find((a) => a.value === stateAbrev.toUpperCase());
    if (state === undefined) {
        return '';
    }
    return state.label;
};
/** Build the Date Range options. */
function GetUSStateOptions(country) {
    if (country === 'US') {
        return [
            {
                label: '',
                value: ''
            },
            {
                label: 'Alabama',
                value: 'AL'
            },
            {
                label: 'Alaska',
                value: 'AK'
            },
            {
                label: 'Arizona',
                value: 'AZ'
            },
            {
                label: 'Arkansas',
                value: 'AR'
            },
            {
                label: 'California',
                value: 'CA'
            },
            {
                label: 'Colorado',
                value: 'CO'
            },
            {
                label: 'Connecticut',
                value: 'CT'
            },
            {
                label: 'Delaware',
                value: 'DE'
            },
            {
                label: 'District Of Columbia',
                value: 'DC'
            },
            {
                label: 'Florida',
                value: 'FL'
            },
            {
                label: 'Georgia',
                value: 'GA'
            },
            {
                label: 'Hawaii',
                value: 'HI'
            },
            {
                label: 'Idaho',
                value: 'ID'
            },
            {
                label: 'Illinois',
                value: 'IL'
            },
            {
                label: 'Indiana',
                value: 'IN'
            },
            {
                label: 'Iowa',
                value: 'IA'
            },
            {
                label: 'Kansas',
                value: 'KS'
            },
            {
                label: 'Kentucky',
                value: 'KY'
            },
            {
                label: 'Louisiana',
                value: 'LA'
            },
            {
                label: 'Maine',
                value: 'ME'
            },
            {
                label: 'Maryland',
                value: 'MD'
            },
            {
                label: 'Massachusetts',
                value: 'MA'
            },
            {
                label: 'Michigan',
                value: 'MI'
            },
            {
                label: 'Minnesota',
                value: 'MN'
            },
            {
                label: 'Mississippi',
                value: 'MS'
            },
            {
                label: 'Missouri',
                value: 'MO'
            },
            {
                label: 'Montana',
                value: 'MT'
            },
            {
                label: 'Nebraska',
                value: 'NE'
            },
            {
                label: 'Nevada',
                value: 'NV'
            },
            {
                label: 'New Hampshire',
                value: 'NH'
            },
            {
                label: 'New Jersey',
                value: 'NJ'
            },
            {
                label: 'New Mexico',
                value: 'NM'
            },
            {
                label: 'New York',
                value: 'NY'
            },
            {
                label: 'North Carolina',
                value: 'NC'
            },
            {
                label: 'North Dakota',
                value: 'ND'
            },
            {
                label: 'Ohio',
                value: 'OH'
            },
            {
                label: 'Oklahoma',
                value: 'OK'
            },
            {
                label: 'Oregon',
                value: 'OR'
            },
            {
                label: 'Pennsylvania',
                value: 'PA'
            },
            {
                label: 'Puerto Rico',
                value: 'PR'
            },
            {
                label: 'Rhode Island',
                value: 'RI'
            },
            {
                label: 'South Carolina',
                value: 'SC'
            },
            {
                label: 'South Dakota',
                value: 'SD'
            },
            {
                label: 'Tennessee',
                value: 'TN'
            },
            {
                label: 'Texas',
                value: 'TX'
            },
            {
                label: 'Utah',
                value: 'UT'
            },
            {
                label: 'Vermont',
                value: 'VT'
            },
            {
                label: 'Virginia',
                value: 'VA'
            },
            {
                label: 'Washington',
                value: 'WA'
            },
            {
                label: 'West Virginia',
                value: 'WV'
            },
            {
                label: 'Wisconsin',
                value: 'WI'
            },
            {
                label: 'Wyoming',
                value: 'WY'
            },
        ];
    }
    else if (country === 'CA') {
        return [
            {
                label: '',
                value: ''
            },
            {
                label: 'Alberta',
                value: 'AB'
            },
            {
                label: 'British Columbia',
                value: 'BC'
            },
            {
                label: 'Mabitoba',
                value: 'MB'
            },
            {
                label: 'New Brunswick',
                value: 'NB'
            },
            {
                label: 'Newfoundland and Labrador',
                value: 'NL'
            },
            {
                label: 'Northwest Territories',
                value: 'NT'
            },
            {
                label: 'Nova Scotia',
                value: 'NS'
            },
            {
                label: 'Nunavut',
                value: 'NU'
            },
            {
                label: 'Ontario',
                value: 'ON'
            },
            {
                label: 'Prince Edward Island',
                value: 'PE'
            },
            {
                label: 'Quebec',
                value: 'QC'
            },
            {
                label: 'Saskatchewan',
                value: 'SK'
            },
            {
                label: 'Yukon',
                value: 'YT'
            },
        ];
    }
    else {
        return [
            {
                label: '',
                value: ''
            },
            {
                label: 'Alabama',
                value: 'AL'
            },
            {
                label: 'Alaska',
                value: 'AK'
            },
            {
                label: 'Alberta',
                value: 'AB'
            },
            {
                label: 'Arizona',
                value: 'AZ'
            },
            {
                label: 'Arkansas',
                value: 'AR'
            },
            {
                label: 'British Columbia',
                value: 'BC'
            },
            {
                label: 'California',
                value: 'CA'
            },
            {
                label: 'Colorado',
                value: 'CO'
            },
            {
                label: 'Connecticut',
                value: 'CT'
            },
            {
                label: 'Delaware',
                value: 'DE'
            },
            {
                label: 'District Of Columbia',
                value: 'DC'
            },
            {
                label: 'Florida',
                value: 'FL'
            },
            {
                label: 'Georgia',
                value: 'GA'
            },
            {
                label: 'Hawaii',
                value: 'HI'
            },
            {
                label: 'Idaho',
                value: 'ID'
            },
            {
                label: 'Illinois',
                value: 'IL'
            },
            {
                label: 'Indiana',
                value: 'IN'
            },
            {
                label: 'Iowa',
                value: 'IA'
            },
            {
                label: 'Kansas',
                value: 'KS'
            },
            {
                label: 'Kentucky',
                value: 'KY'
            },
            {
                label: 'Louisiana',
                value: 'LA'
            },
            {
                label: 'Maine',
                value: 'ME'
            },
            {
                label: 'Mabitoba',
                value: 'MB'
            },
            {
                label: 'Maryland',
                value: 'MD'
            },
            {
                label: 'Massachusetts',
                value: 'MA'
            },
            {
                label: 'Michigan',
                value: 'MI'
            },
            {
                label: 'Minnesota',
                value: 'MN'
            },
            {
                label: 'Mississippi',
                value: 'MS'
            },
            {
                label: 'Missouri',
                value: 'MO'
            },
            {
                label: 'Montana',
                value: 'MT'
            },
            {
                label: 'Nebraska',
                value: 'NE'
            },
            {
                label: 'Nevada',
                value: 'NV'
            },
            {
                label: 'New Brunswick',
                value: 'NB'
            },
            {
                label: 'New Hampshire',
                value: 'NH'
            },
            {
                label: 'New Jersey',
                value: 'NJ'
            },
            {
                label: 'New Mexico',
                value: 'NM'
            },
            {
                label: 'New York',
                value: 'NY'
            },
            {
                label: 'Newfoundland and Labrador',
                value: 'NL'
            },
            {
                label: 'North Carolina',
                value: 'NC'
            },
            {
                label: 'North Dakota',
                value: 'ND'
            },
            {
                label: 'Northwest Territories',
                value: 'NT'
            },
            {
                label: 'Nova Scotia',
                value: 'NS'
            },
            {
                label: 'Nunavut',
                value: 'NU'
            },
            {
                label: 'Ohio',
                value: 'OH'
            },
            {
                label: 'Oklahoma',
                value: 'OK'
            },
            {
                label: 'Ontario',
                value: 'ON'
            },
            {
                label: 'Oregon',
                value: 'OR'
            },
            {
                label: 'Pennsylvania',
                value: 'PA'
            },
            {
                label: 'Prince Edward Island',
                value: 'PE'
            },
            {
                label: 'Puerto Rico',
                value: 'PR'
            },
            {
                label: 'Quebec',
                value: 'QC'
            },
            {
                label: 'Rhode Island',
                value: 'RI'
            },
            {
                label: 'Saskatchewan',
                value: 'SK'
            },
            {
                label: 'South Carolina',
                value: 'SC'
            },
            {
                label: 'South Dakota',
                value: 'SD'
            },
            {
                label: 'Tennessee',
                value: 'TN'
            },
            {
                label: 'Texas',
                value: 'TX'
            },
            {
                label: 'Utah',
                value: 'UT'
            },
            {
                label: 'Vermont',
                value: 'VT'
            },
            {
                label: 'Virginia',
                value: 'VA'
            },
            {
                label: 'Washington',
                value: 'WA'
            },
            {
                label: 'West Virginia',
                value: 'WV'
            },
            {
                label: 'Wisconsin',
                value: 'WI'
            },
            {
                label: 'Wyoming',
                value: 'WY'
            },
            {
                label: 'Yukon',
                value: 'YT'
            },
        ];
    }
}
//# sourceMappingURL=StateListHelper.js.map